import { useContext, useEffect, useState } from "react";
import { GetTeacherById  } from "../../../components/exl/requests/TeacherRequests";
import { DataContext } from "../../../store";
import { GetEmployeeInfo, GetEmployeePhoto } from "../../.././functions/fetch/employee";
import { navigate } from 'hookrouter'
import { DataContext as SharedDataContext} from '../../../.././src/./stores/crm-store'
import { GetCoursesByTeacherId } from "../../../components/exl/requests/CourseRequests";
import { DataContext as TeacherCoursesTableDataContext } from "../../../../src/stores/teacher-course-table-store.js";
import { courseStatusOptions } from "../../../components/exl/shared/translations";

const getTeacherData = async (id, updateTeacherState, updatePdfUrlState, sharedDispatch) => {

    let teacherResponse = await GetTeacherById(id);



    if(teacherResponse !== null) {
        let teacherEmployee = null;

        teacherEmployee = await GetEmployeePhoto(teacherResponse.coaEmpId);

        if(teacherEmployee.err) {
            teacherResponse.photo = null;
        }
        else{
            teacherResponse.photo = teacherEmployee.data;
        }

        updateTeacherState(teacherResponse);
    }else{
        navigate('/error');
    }

}

const getTeacherUser = async (user, updateTeacherUserState, teacher, setLoading) => {
    const isAdmin = (user.isExlAdmin || user.isAdmin);
    const id = user.id;

    if (teacher.coaEmpId === null) {
        updateTeacherUserState({
            editPermission: isAdmin,
            compensationTypePermission: false,
            coaEmpId: id,
        });
        setLoading(false);
        return;
    }

    const teacherEmployee = await GetEmployeeInfo(teacher.coaEmpId, 'info');
    
    let isBossOfEmp = false;
    let isMyself = false;
    
    if(teacherEmployee) {
        isBossOfEmp = teacherEmployee.data.isBossOfEmp;
        isMyself = teacherEmployee.data.isMyself;   
    }
    const canSeeCompensationType = isAdmin || isBossOfEmp || isMyself;

    updateTeacherUserState({
        editPermission: isAdmin,
        compensationTypePermission: canSeeCompensationType,
        coaEmpId: id,
    });
    setLoading(false);
}

const getTeacherCourses = async (teacherId, filters, updateTeacherCoursesState) => {
    const teacherCoursesResponse = await GetCoursesByTeacherId(teacherId,JSON.stringify(filters));
    updateTeacherCoursesState(teacherCoursesResponse);
}

export default function useTeacherDetails(teacherId) {
    const [teacher, setTeacher] = useState(null);
    const [loading, setLoading] = useState(false);
    const [teacherUser, setTeacherUser] = useState(null);
    const [teacherCourses, setTeacherCourses] = useState(null);

    const refreshTeacherData = () => {
        getTeacherData(teacherId, setTeacher, sharedDispatch);
    } 

    const {
        store: {user},
    } = useContext(DataContext);

    const {
        store: {filters, isResettingFilters},
        dispatch} = useContext(TeacherCoursesTableDataContext);

    const { dispatch: sharedDispatch } = useContext(SharedDataContext);

    useEffect(() => {
        setLoading(true);
        if (!teacher || teacher?.id !== teacherId) {
            dispatch({ type: 'RESET_FILTERS' });
            getTeacherData(teacherId, setTeacher, sharedDispatch);
            getTeacherCourses(teacherId, filters, setTeacherCourses);
        }

        if(user && teacher) {
            getTeacherUser(user, setTeacherUser, teacher, setLoading);
        }
    },[teacherId, user, teacher]);

    useEffect(() => {
        getTeacherCourses(teacherId, filters, setTeacherCourses);
    }, [filters]);

    useEffect(() => {
        if (!isResettingFilters) {
            getTeacherCourses(teacherId, filters, setTeacherCourses);
        }
    }, [isResettingFilters]);

    return {
        teacher,
        loading,
        teacherUser,
        teacherCourses,
        refreshTeacherData,
    }
}
